import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";

async function getAll() {
  const response = await http.getData("/master-regimen-kemoterapi").catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response.data;
}

async function getDetail(id) {
  const response = await http.getData(`/master-regimen-kemoterapi/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response.data;
}

export default {
  getAll,
  getDetail,
};
